// Destinos dos CTAs da landing.
export const LINKS = {
  register: "/register",
  login: "/login",
  // TODO: trocar pelos links reais das lojas quando publicados.
  appAndroid: "#",
  appIos: "#",
  // Páginas legais (LGPD).
  privacy: "/privacidade",
  terms: "/termos",
  lgpd: "/lgpd",
} as const
